import { useQuery } from '@tanstack/react-query';
import { peopleCoreAPI } from '@/shared/lib/api';
import type { Employee } from '../types';

export function useEmployees() {
  return useQuery<Employee[]>({
    queryKey: ['people-core', 'employees'],
    queryFn: async () => {
      try {
        const res = await peopleCoreAPI.listEmployees();
        return res.data.data ?? [];
      } catch (error) {
        // Se der erro 403 (colaborador tentando acessar), retorna array vazio
        // Admin/Gestor devem ter acesso normalmente
        return [];
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: false, // Não tentar novamente se der erro 403
  });
}

/**
 * Hook para buscar o perfil do próprio colaborador (qualquer role)
 * Usado quando o colaborador precisa do próprio dailyWorkHours
 */
export function useMyProfile() {
  return useQuery<Employee>({
    queryKey: ['people-core', 'employees', 'me'],
    queryFn: async () => {
      const res = await peopleCoreAPI.getMyProfile();
      return res.data.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
